import React from "react";
import "./Vendor_Tab_History.css";
import Common_Vendor_Cards_History_Onlogin from "../../../common_components/common-vendor-cards-history-onlogin/Common_Vendor_Cards_History_Onlogin";

const experts = [
  {
    id: 1,
    name: "Aditya nitin jadhav",
    mobile_no: "+91 9945854712",
    whatsapp_no: "+91 9965845321",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img2.png",
  },
  {
    id: 2,
    name: "Rajesh anil kumar",
    mobile_no: "+91 9954758952",
    whatsapp_no: "+91 9965845321",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img1.png",
  },
  {
    id: 3,
    name: "Prathamesh viraj raut",
    mobile_no: "+91 9945854712",
    whatsapp_no: "+91 9954568756",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img3.png",
  },
  {
    id: 4,
    name: "Prathamesh viraj raut",
    mobile_no: "+91 9945854712",
    whatsapp_no: "+91 9954568756",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img3.png",
  },
  {
    id: 5,

    name: "Rajesh anil kumar",
    mobile_no: "+91 9954758952",
    whatsapp_no: "+91 9965845321",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img1.png",
  },
  {
    id: 6,

    name: "Aditya nitin jadhav",
    mobile_no: "+91 9945854712",
    whatsapp_no: "+91 9965845321",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img2.png",
  },
  {
    id: 7,
    name: "Prathamesh viraj raut",
    mobile_no: "+91 9945854712",
    whatsapp_no: "+91 9954568756",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img3.png",
  },
  {
    id: 8,
    name: "Aditya nitin jadhav",
    mobile_no: "+91 9945854712",
    whatsapp_no: "+91 9965845321",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img2.png",
  },
  {
    id: 9,

    name: "Rajesh anil kumar",
    mobile_no: "+91 9954758952",
    whatsapp_no: "+91 9965845321",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img1.png",
  },
  {
    id: 10,

    name: "Rajesh anil kumar",
    mobile_no: "+91 9954758952",
    whatsapp_no: "+91 9965845321",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img1.png",
  },
  {
    id: 11,

    name: "Aditya nitin jadhav",
    mobile_no: "+91 9945854712",
    whatsapp_no: "+91 9965845321",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img2.png",
  },
  {
    id: 12,
    name: "Prathamesh viraj raut",
    mobile_no: "+91 9945854712",
    whatsapp_no: "+91 9954568756",
    city: "Pune",
    state: "Maharashtra",
    image: "/assets/images/history-img3.png",
  },
];

function Vendor_Tab_History() {
  return (
    <div className="container mt-4 history-section">
      <div className="row">
        {experts.map((item) => (
          <div key={item.id} className="col-12 col-md-6 col-lg-4 mb-4">
            <Common_Vendor_Cards_History_Onlogin data={item} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Vendor_Tab_History;
